var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.loading ? _c('Loading', {
    attrs: {
      "background-color": '#ffffff',
      "opacity": 0.4
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "panel"
  }, [!_vm.moduleConfig.hasOwnProperty('display_current_points') || _vm.moduleConfig.display_current_points ? _c('div', {
    staticClass: "panel__col"
  }, [_c('div', {
    staticClass: "panel__name"
  }, [_vm._v(_vm._s(_vm.moduleConfig.points_name || '總點數'))]), _c('div', {
    staticClass: "panel__value"
  }, [_vm._v(" " + _vm._s(_vm.formattedUserPoints))])]) : _vm._e(), !_vm.moduleConfig.hasOwnProperty('display_expired_points') || _vm.moduleConfig.display_expired_points ? _c('div', {
    staticClass: "panel__col"
  }, [_c('div', {
    staticClass: "panel__name"
  }, [_vm._v(" " + _vm._s(_vm.formattedExpiringSoonPointsDate) + _vm._s(_vm.moduleConfig.expired_points_name || '到期點數') + " ")]), _c('div', {
    staticClass: "panel__value d-flex justify-content-between"
  }, [_vm._v(" " + _vm._s(_vm.formattedExpiringSoonPoints) + " "), _vm.expiringSoonPoints > 0 && _vm.$route.name !== 'LiffPointsExpiring' && _vm.moduleConfig.display_expired_point_list ? _c('router-link', {
    staticClass: "btn btn-sm font-weight-normal",
    attrs: {
      "to": {
        name: 'LiffPointsExpiring'
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-information-outline"
  }), _vm._v(" " + _vm._s(_vm.moduleConfig.expired_point_list_name || '查看') + " ")]) : _vm._e()], 1)]) : _vm._e()])], 1), _vm.isIndividualTab ? _c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "currentTab": _vm.currentTab
    }
  }) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }